import { toast } from 'react-toastify';

// import { store } from 'core/store';

let isDevVisible = false

export const setDevVisible = (val: boolean) => {
  isDevVisible = val
}

function normalizeJson(value: string | object) {
  if (typeof value === 'string') {
      return value;
  }
  return JSON.stringify(value); // уже объект
}

export const showApiErrors = (error: any) => {
  if(!isDevVisible) return
  
  const text = `  URL: ${normalizeJson(error.config?.url)}\n  Тело: ${normalizeJson(error.config?.data)}\n  Ответ: ${normalizeJson(error.response?.data)}`
  
  toast.error(
    <div>
      <pre style={{ maxHeight: 200, overflow: 'auto' }}>
        {text}
      </pre>
  
      <button onClick={() => navigator.clipboard.writeText(text)}>
        Copy
      </button>
    </div>,
    { autoClose: 2000, position: 'top-center'  }
  );
}

